import React from "react";
import CategoryPage from "./CategoryPage";

function Editorial({ posts, publications }) {

  return (
    <CategoryPage
      title="Editorial"
      posts={posts}
      publications={publications}
    />
  );

}

export default Editorial;